import React, { FC, HTMLAttributes } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { cn } from '../lib/utils';
import Typography from '../Typography/Typography';

type UploadImagePreviewProps = {
  preview: string;
  handleRemoveImage: () => void;
} & HTMLAttributes<HTMLDivElement>;

export const UploadImagePreview: FC<UploadImagePreviewProps> = ({
  preview,
  handleRemoveImage,
  className,
  style,
  ...rest
}) => (
  <div
    className={cn(
      'group/preview relative h-[77px] w-[134px] shrink-0 overflow-hidden rounded-[10px]',
      className
    )}
    style={style}
    {...rest}
  >
    <div className="absolute inset-[10px] flex items-center justify-center overflow-hidden">
      <img
        src={preview}
        alt=""
        className="max-h-full max-w-full object-contain"
        draggable={false}
      />
    </div>
    <div
      className="pointer-events-none absolute inset-0 rounded-[10px] bg-[linear-gradient(180deg,rgba(184,184,184,0)_0%,rgba(0,0,0,0.25)_100%)]"
      aria-hidden
    />
    <div
      data-testid="ContentForm-ThumbnailUpload-Overlay"
      className="absolute left-0 top-0 z-10 hidden h-full w-full cursor-pointer rounded-[10px] opacity-0 group-hover/preview:flex group-hover/preview:items-center group-hover/preview:justify-center group-hover/preview:bg-button-hover-upload-change group-hover/preview:opacity-100"
    >
      <Typography className="text-p-xs text-base-popover">Change</Typography>
      <FontAwesomeIcon
        data-testid="ContentForm-ThumbnailUpload-Remove"
        icon="fa-regular fa-trash"
        onClick={(event: any) => {
          event.stopPropagation();
          handleRemoveImage();
        }}
        className="absolute right-1.5 top-1.5 h-6 w-6 rounded-lg bg-[rgba(255,255,255,0.10)] p-1 text-[10px] text-white hover:bg-[rgba(255,255,255,0.30)]"
      />
    </div>
  </div>
);
